export default __webpack_public_path__ + "static/media/pawprint.d89d14d4.png";